import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Paper, Stack, Alert } from '@mui/material';
import { Assignment as ProjectIcon, ArrowForward as ArrowIcon } from '@mui/icons-material';
import ContentWrapper from '../../layout/ContentWrapper';

const ProjectSelect: React.FC = () => {
  return (
    <ContentWrapper>
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <Paper
          sx={{
            p: 6,
            textAlign: 'center',
            maxWidth: 500,
            width: '100%',
            boxShadow: 2,
          }}
        >
          <Stack spacing={3} alignItems="center">
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                backgroundColor: 'primary.light',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
              }}
            >
              <ProjectIcon sx={{ fontSize: 40, color: 'white' }} />
            </Box>

            <Typography variant="h4" component="h1" gutterBottom>
              Select a Project
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              You need to select an R&D project before you can access activities, transactions, and
              reports. Choose from your existing projects or create a new one.
            </Typography>
            <Alert variant="outlined" severity="info" sx={{ mb: 4 }}>
              Choose a project from the project menu at the top left of the screen.
            </Alert>

            {/* <Button
              variant="outlined"
              component={RouterLink}
              to="/app/projects"
              endIcon={<ArrowIcon />}
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '1.1rem',
              }}
            >
              Choose Project
            </Button> */}
          </Stack>
        </Paper>
      </Box>
    </ContentWrapper>
  );
};

export default ProjectSelect;
